import React from 'react'
import { _Object } from 'utils/interfaces'
import ReactPaginate from 'react-paginate'

const Pagination = ({ total_pages, onClick, current_page = 1, per_page = 10, total_items = 0 }: _Object) => {

  const from = total_items === 0 ? 0 : (current_page - 1) * per_page + 1
  const to = Math.min(current_page * per_page, total_items)

  return (
    <>
      <div className="pagination-wrap">
     <div className="pagination-info d-flex align-items-center">
        Showing {from} to {to} of {total_items?.toLocaleString()} entries
      </div>
        <ReactPaginate
          breakLabel=""
          nextLabel=">"
          previousLabel="<"
          onPageChange={onClick}
          pageCount={total_pages}
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link previous-arrow"
          nextClassName="page-item"
          nextLinkClassName="page-link next-arrow"
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
        />
      </div>
    </>
  )
}
export default Pagination


